import { createApp } from 'vue'
import Frontpage from '~/components/frontpage.vue'
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';

const app = createApp(Frontpage)
app.component('Frontpage', Frontpage)
app.mount('#frontpage')